"use strict";
import Auth from "../../util/auth";
export function init(ports) {
  ports.safeSubscribe("needsUnauthorized", () => {
    Auth.reset();
    window.location.reload();
  });
}
